// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let PathwrightPlan
export default PathwrightPlan = class PathwrightPlan extends (
  require("lib/static-shim").default(require("lib/utils/model").default)
) {}
